import React, { useEffect, useRef } from 'react';
import s3 from '../assets/img/houselist.jpg';
import s2 from '../assets/img/s0.jpg';
import s1 from '../assets/img/Services-pages3.png';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/ServicesPages.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const Services_Page = ({ isMobileMenuOpen }) => {
    const containerRef = useRef(null);
    const sliderRef = useRef(null);
    const imageRefs = useRef([]);

    // Clear and set refs
    imageRefs.current = [];
    const addToImageRefs = (el) => {
        if (el && !imageRefs.current.includes(el)) {
            imageRefs.current.push(el);
        }
    };

    useEffect(() => {
      window.scrollTo(0, 0);
  
      const totalPanels = 3;
  
      const scrollTrigger = ScrollTrigger.create({
          trigger: '.services-slider-container',
          start: 'top top',
          end: '+=200%',
          pin: true,
          pinSpacing: true,
          scrub: 0.5,
          onUpdate: (self) => {
              const progress = self.progress;
  
              const maxMove = (totalPanels - 1) * 100;
              const xPosition = Math.min(progress * maxMove, maxMove);
  
              gsap.set(sliderRef.current, {
                  x: `-${xPosition}vw`,
              });
  
              imageRefs.current.forEach((img, index) => {
                  const parallaxFactor = 50; // Ajustăm factorul de parallax
                  const direction = index % 2 === 0 ? -1 : 1;
  
                  const imgPosition = direction * parallaxFactor * progress;
  
                  // Obținem dimensiunile containerului desc-img
                  const descImg = img.parentElement;
                  const descImgWidth = descImg.offsetWidth;
                  const imgWidth = img.offsetWidth;
  
                  // Calculăm limitele de mișcare
                  const maxTranslateX = (imgWidth - descImgWidth) / 2;
                  const minTranslateX = -maxTranslateX;
  
                  // Limităm mișcarea
                  const translateX = Math.max(minTranslateX, Math.min(maxTranslateX, imgPosition));
  
                  gsap.set(img, {
                      x: translateX,
                      xPercent: 0, 
                  });
              });
          },
      });
  
      return () => {
          if (scrollTrigger) scrollTrigger.kill();
      };
  }, []);

    return (
        <>
            <div id="services-page" ref={containerRef}>
                <div className="relative z-30">
                    <Header />
                    <div className="services-slider-container py-4 my-6">
                        <div ref={sliderRef} className="services-slider flex flex-nowrap">
                            {/* Service 1 */}
                            <div className="service-section flex items-start w-screen px-8">
                                <div className="flex md:flex-row gap-8 items-start">
                                    <div className='img_serv_wrap w-1/2'>
                                        <div className="relative h-[300px] md:h-[400px] desc-img overflow-hidden rounded-[0.5rem]">
                                            <img
                                                ref={addToImageRefs}
                                                src={s1}
                                                className="h-[400px] object-cover rounded-[0.5rem] parallax-img"
                                                alt="service_img1"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-white w-full md:w-1/2">
                                        <h1 className="text-[2rem] xl:text-[3rem] lg:text-[3rem] md:text-[3rem] leading-tight">
                                            REAL ESTATE BROKERAGE
                                        </h1>
                                        <div className="mt-4">
                                            <h3 className="inline-block mb-4 text-[1.2rem] xl:text-[1.3rem] lg:text-[1.3rem] md:text-[1.3rem]">
                                                FAMILY, EXPERIENCE
                                            </h3>
                                            <p className="mt-2 max-w-lg leading-[1.1]">
                                                EstateLand is not only a brokerage agency but above all it is a family story,
                                                from father to son. Beyond the experience and abilities required by the real
                                                estate profession, an effective broker is above all a human being endowed with
                                                empathy and numerous ethical values. A story built tirelessly over the last
                                                30 years, earning the trust and invaluable.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Service 2 - Fixed ordering */}
                            <div className="service-section flex items-start w-screen px-8">
                                <div className="flex md:flex-row gap-8 items-start">
                                    <div className='img_serv_wrap w-1/2'>
                                        <div className="relative h-[300px] md:h-[400px] desc-img overflow-hidden rounded-[0.5rem]">
                                            <img
                                                ref={addToImageRefs}
                                                src={s2}
                                                className="h-[400px] object-cover rounded-[0.5rem] parallax-img"
                                                alt="service_img2"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-white w-full md:w-1/2">
                                        <h1 className="text-[2rem] xl:text-[3rem] lg:text-[3rem] md:text-[3rem] leading-tight">
                                            PROPERTY BROKERAGE
                                        </h1>
                                        <div className="mt-4">
                                            <h3 className="inline-block mb-4 text-[1.2rem] xl:text-[1.3rem] lg:text-[1.3rem] md:text-[1.3rem]">
                                                ANOTHER WAY TO INVEST
                                            </h3>
                                            <p className="mt-2 max-w-lg leading-[1.1]">
                                                There are as many investments as there are investors. Not everyone is equal, and above all,
                                                they do not aim for the same objectives. Whether you are looking to create wealth or develop
                                                it, the choice of real estate is strategic. Estate Land supports you through the numerous
                                                procedures and offers you its analysis.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Service 3 */}
                            <div className="service-section flex items-start w-screen px-8">
                                <div className="flex md:flex-row gap-8 items-start">
                                    <div className='img_serv_wrap w-1/2'>
                                        <div className="relative h-[300px] md:h-[400px] desc-img overflow-hidden rounded-[0.5rem]">
                                            <img
                                                ref={addToImageRefs}
                                                src={s3}
                                                className="h-[400px] object-cover rounded-[0.5rem] parallax-img"
                                                alt="service_img3"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-white w-full md:w-1/2">
                                        <h1 className="text-[2rem] xl:text-[3rem] lg:text-[3rem] md:text-[3rem] leading-tight">
                                            PROPERTY VALUATION
                                        </h1>
                                        <div className="mt-4">
                                            <h3 className="inline-block mb-4 text-[1.2rem] xl:text-[1.3rem] lg:text-[1.3rem] md:text-[1.3rem]">
                                                FINDING THE POTENTIAL IN EVERYTHING
                                            </h3>
                                            <p className="mt-2 max-w-lg leading-[1.1]">
                                                Valuing your land or property is a long process. This requires knowing
                                                how to take the time to consider all possible options. This consists of
                                                the development of a project, its financing and this until its marketing
                                                or rental. It is therefore fundamental to be closely supported on this
                                                path.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Services_Page;